

const Container = ({children}) => {
    return <div className="w-[1300px] mx-auto">
        {children}
    </div>
}

export default Container;


